
































import { Component, Mixins } from "vue-property-decorator";
import {
  BiaggregateAisummaryPromptTemplate,
  DefaultBiaggregateAisummaryPromptTemplate,
} from "#/model/biaggregate";
import PromptTemplateEdit from "@/components/biaggregate/aisummary/PromptTemplateEdit.vue";
import PromptTemplateExperiment from "@/components/biaggregate/aisummary/PromptTemplateExperiment.vue";
import AxiosMixin from "@/mixins/axiosMixin";
import RulesMixin from "#/mixins/rulesMixin";
import UtilMixin from "@/mixins/utilMixin";

@Component({
  components: {
    PromptTemplateEdit,
    PromptTemplateExperiment,
  },
})
export default class extends Mixins(AxiosMixin, UtilMixin, RulesMixin) {
  /** タブ */
  private tab = 0;

  /** 編集モード */
  private mode = "";

  /** 集計AIサマリプロンプトテンプレート */
  private promptTemplate: BiaggregateAisummaryPromptTemplate =
    DefaultBiaggregateAisummaryPromptTemplate();

  /** コピーモード */
  private get IsCopyMode(): boolean {
    return this.mode == "copy";
  }

  created() {
    this.mode = this.$route.query.mode as string;
    this.fetch();
  }

  /** 集計AIサマリプロンプトテンプレート取得 */
  private fetch() {
    const promptTemplateId = Number(this.$route.params.id);
    this.postJsonCheck(
      window.base_url + "/api/admin/biaggregate/aisummary/prompt/get",
      { id: promptTemplateId },
      async (res) => {
        this.promptTemplate = res.data.prompt_template;

        if (this.IsCopyMode) {
          this.promptTemplate.name += "のコピー";
          this.promptTemplate.comment = "";
        }
      }
    );
  }

  /** 集計AIサマリプロンプトテンプレート保存 */
  private async save() {
    // 既存テンプレートのコピー時はid=0にして新規作成扱い
    if (this.IsCopyMode) {
      this.promptTemplate.id = 0;
      this.promptTemplate.blocks.forEach((block) => {
        block.id = 0;
        block.biaggregate_aisummary_prompt_template_id = 0;
      });
    }

    this.postJsonCheck(
      window.base_url + "/api/admin/biaggregate/aisummary/prompt/save",
      { prompt_template: this.promptTemplate },
      async () => {
        this.moveToListPage();
      }
    );
  }

  /** 集計AIサマリプロンプトテンプレート削除 */
  private async deletePromptTemplate() {
    this.postJsonCheck(
      window.base_url + "/api/admin/biaggregate/aisummary/prompt/delete",
      { prompt_template: this.promptTemplate },
      async () => {
        this.moveToListPage();
      }
    );
  }

  /** 編集キャンセル */
  private cancel() {
    this.moveToListPage();
  }

  /** AI分析設定画面へ遷移 */
  private moveToListPage() {
    this.$router.push({ path: "/biaggregate/aisummary/configuration/show" });
  }
}
